import DamageTypePage from "@/components/damageType/DamageTypePage";

const PatientendatenDiebstahl = () => <DamageTypePage slug="patientendaten-diebstahl" />;
export default PatientendatenDiebstahl;
